// extracted by mini-css-extract-plugin
export var about = "style-module--about--e69f3";
export var about__block = "style-module--about__block--1bec9";
export var about__blocks = "style-module--about__blocks--a4461";
export var about__content = "style-module--about__content--04890";
export var about__docs = "style-module--about__docs--6dd93";
export var about__docsImgs = "style-module--about__docs-imgs--00078";
export var about__docs__img = "style-module--about__docs__img--fd913";
export var about__image = "style-module--about__image--741b1";
export var about__rocket = "style-module--about__rocket--c9e5e";
export var about__text = "style-module--about__text--2074d";
export var about__wrapper = "style-module--about__wrapper--16e92";